import Breadcumb from '../../components/Breadcumb'
import DiscoverNFTInDetails from "./DiscoverNFTInDetails"
import data from '../../data/data-containers/data-ItemDetails'
import SEO from "../../components/Seo"

const ItemDetailsContainer = () => {

  return (
    <>
      <SEO title="Item Details" />
      <main>
        <Breadcumb title='Item Details' />
        <DiscoverNFTInDetails data={data[0].DiscoverNFTInDetails} />
      </main>
    </>
  );
}

export default ItemDetailsContainer;